// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2256":"2364484e","6093":"bd7eb15c","7937":"bd7eb15c","8688":"c979e12a"}[chunkId] + ".chunk.css";
};